import * as React from "react";
import { forwardRef } from "react";
const SvgArrowBlue = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.8335 5.66675L7.8335 10.6667L12.8335 5.66675", stroke: "#0191F8", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowBlue);
export default ForwardRef;
